import { render, staticRenderFns } from "./KOSDAQ.vue?vue&type=template&id=46a4bd47"
import script from "./KOSDAQ.vue?vue&type=script&lang=js"
export * from "./KOSDAQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports